module.exports = {"title":{},"placeholders":{"bold":"粗体","del":"删除线","underline":"下划线","italic":"斜体","quote":"引用","bookmark":"标记","superscript":"上角标","subscript":"下角标","h1":"标题1","h2":"标题2","h3":"标题3","h4":"标题4","h5":"标题5","h6":"标题6","alignLeft":"左对齐","alignCenter":"居中对齐","alignRight":"右对齐","ol":"","ul":"","hr":"","link":"http://","inlineFormula":"latex行内公式","interlineFormula":"latex行间公式","inlineCode":"行内代码","code":""}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/lang/en/words.json
// module id = 358
// module chunks = 0